import script from "./ModalTrigger.vue?vue&type=script&lang=js"
export * from "./ModalTrigger.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__